import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import { WS_URL } from '../config/axios';

const payloadHandlers = new Set();
const connectionHandlers = new Set();

let stompClient = null;
let connectedUserId = null;
let connected = false;
let activateTimeoutId = null;

const notifyConnectionHandlers = (nextConnected) => {
  connectionHandlers.forEach((handler) => {
    try {
      handler(nextConnected);
    } catch (error) {
      console.error('Chat STOMP connection handler 오류:', error);
    }
  });
};

const setConnected = (nextConnected) => {
  if (connected === nextConnected) return;
  connected = nextConnected;
  notifyConnectionHandlers(nextConnected);
};

const dispatchPayload = (payload) => {
  payloadHandlers.forEach((handler) => {
    try {
      handler(payload);
    } catch (error) {
      console.error('Chat STOMP payload handler 오류:', error);
    }
  });
};

export const addChatStompPayloadHandler = (handler) => {
  payloadHandlers.add(handler);
};

export const removeChatStompPayloadHandler = (handler) => {
  payloadHandlers.delete(handler);
};

export const addChatStompConnectionHandler = (handler) => {
  connectionHandlers.add(handler);
  handler(connected);
};

export const removeChatStompConnectionHandler = (handler) => {
  connectionHandlers.delete(handler);
};

export const ensureChatStompConnected = (userId) => {
  if (!userId) return;
  if (stompClient && connectedUserId === userId) return;

  disconnectChatStomp();
  connectedUserId = userId;

  const socket = new SockJS(WS_URL);
  const nextClient = new Client({
    webSocketFactory: () => socket,
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
    onConnect: () => {
      setConnected(true);
      nextClient.subscribe(`/topic/chat/${userId}`, (message) => {
        if (!message.body) return;
        try {
          dispatchPayload(JSON.parse(message.body));
        } catch (error) {
          console.error('Chat STOMP 본문 파싱 실패:', error);
        }
      });
    },
    onWebSocketClose: () => {
      setConnected(false);
    },
    onWebSocketError: (error) => {
      console.error('Chat STOMP WebSocket 오류:', error);
      setConnected(false);
    },
    onStompError: (frame) => {
      console.error('Chat STOMP 오류:', frame);
    },
  });

  stompClient = nextClient;
  activateTimeoutId = setTimeout(() => {
    nextClient.activate();
  }, 0);
};

export const disconnectChatStomp = () => {
  if (activateTimeoutId !== null) {
    clearTimeout(activateTimeoutId);
    activateTimeoutId = null;
  }
  try {
    stompClient?.deactivate();
  } catch (_) {
    // 이미 비활성화된 경우 무시
  }
  stompClient = null;
  connectedUserId = null;
  setConnected(false);
};

export const isChatStompConnected = () => connected;
